import { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextInput = ({ value, setFormData, name, label }) => {
  const [touched, setTouched] = useState(false);
  return (
    <div className="mb-4">
      <p className="capitalize mb-2">{label ?? ""}</p>
      <ReactQuill
        theme="snow"
        value={value}
        onBlur={() => {
          setTouched(true);
        }}
        onChange={(val) => {
          setFormData((prevState) => ({
            ...prevState,
            [name]: val,
          }));
        }}
        className="mb-24 sm:mb-14 h-[200px] rounded-md"
      />
      {touched && !Boolean(value) && (
        <p className="text-red-600 mt-4 text-sm">Description is required!</p>
      )}
    </div>
  );
};

export default RichTextInput;
